import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';

export const trackSdkSetupEvent = createTrackerForCategory('SDK Setup');

export const trackCursorSdkInstallButtonClicked = () => trackSdkSetupEvent('Cursor SDK Install Button Clicked');

export const trackSdkSetupGetSupportClicked = () => trackSdkSetupEvent('Get Support Clicked');

export const trackSdkSetupExploreSandboxClicked = () => trackSdkSetupEvent('Explore Sandbox Clicked');

export const trackSdkSetupCloseClicked = () => trackSdkSetupEvent('Close Clicked');

export const trackSdkSetupSdkConnected = (sdk: string) => trackSdkSetupEvent('SDK Connected', { sdk });

export const trackSdkSetupNextStepsCTAClicked = () => trackSdkSetupEvent('Next Steps CTA Clicked');

export const trackSdkSetupSdkSelected = (sdk: string) => trackSdkSetupEvent('SDK Selected', { sdk });

export const trackSdkSetupFilterSelected = (filter: string) => trackSdkSetupEvent('Filter Selected', { filter });

export const trackSdkSetupReadDocsClicked = (sdk: string) => trackSdkSetupEvent('Read Docs Clicked', { sdk });

export const trackSdkSetupSnippetClicked = (snippet: string) => trackSdkSetupEvent('Snippet Clicked', { snippet });

export const trackSdkSetupNoResultsFound = (searchValue: string) =>
  trackSdkSetupEvent('No Results Found', { searchValue });

export const trackSdkSetupPageLoaded = () => trackSdkSetupEvent('SDK Setup Page Loaded');

export const trackSdkSetupDrawerOpened = () => trackSdkSetupEvent('SDK Setup Drawer Opened');

export const trackTargetIndividualUsersSequenceStarted = ({ cta, component }: { cta: string; component: string }) =>
  trackSdkSetupEvent('Target Individual Users Sequence Started', { cta, component });

export const trackInstallSdkClicked = ({ cta, component }: { cta: string; component: string }) =>
  trackSdkSetupEvent('Install SDK Clicked', { cta, component });

export const trackProjectSettingsLinkClicked = (sdk: string) =>
  trackSdkSetupEvent('Project Settings Link Clicked', { sdk });

export const trackSdkKeysLinkClicked = (sdk: string) => trackSdkSetupEvent('SDK Keys Link Clicked', { sdk });

export const trackAgentCommandCopied = () => trackSdkSetupEvent('Agentic Onboarding Command Copied');

export const trackSdkSetupTabSelected = (tab: string) => trackSdkSetupEvent('Tab Selected', { tab });

export const trackSdkSetupResourceLinkClicked = (linkName: string) =>
  trackSdkSetupEvent('Resource Link Clicked', { linkName });
